let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l5wzj")).then(() => parcelRequire('dERdl'));